import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Upload
} from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_CODE, OPTIONS_ROLE, TIME_PAKAGE } from '../../configData'
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { userSearch } from '../../services/cmsservice'
import { upLoadImage } from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
import { removeVietnameseTones } from '../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const { TextArea } = Input

const FormPost = ({ data, form, handleSearch, mode, listDepartmentFull }) => {
  const type = Form.useWatch('type', form)
  const code = Form.useWatch('code', form)
  const [uploading, setUploading] = useState(false)
  const [uploadedFileUrl, setUploadedFileUrl] = useState('')

  const handleUpload = async ({ file }) => {
    const formData = new FormData()
    formData.append('config', file)
    try {
      setUploading(true)
      const response = await upLoadImage(formData)
      const link = response?.data?.[0]?.link
      form.setFieldsValue({ value: link })
      setUploadedFileUrl(link)

      openNotification('success', 'Tải lên thành công!')
    } catch (err) {
      console.error(err)
      openNotification(
        'error',
        err?.response?.data?.message || 'upload thất bại'
      )
    } finally {
      setUploading(false)
    }
  }

  const handleDelete = () => {
    setUploadedFileUrl('')
    form.setFieldsValue({ value: '' })
  }

  useEffect(() => {
    form.setFieldsValue(data)
    if (data?.type == 'link') {
      setUploadedFileUrl(data?.value)
    } else if (data?.type == 'STK') {
      const accountData = JSON.parse(data?.value)
      form.setFieldsValue({
        account_holder: accountData?.accountName,
        account_number: accountData?.accountNumber,
        bank_name: accountData?.bankName
      })
    }else if (data?.code == 'USER_ACCESS') {
      getListUserAccess()
      form.setFieldsValue({ user_access: data?.value?.split(',').map(item => item.trim()).filter(Boolean) })
    }
  }, [data])

  const [listUserAccess, setListUserAccess] = useState([])
  const getListUserAccess = async (values) => {
    const { page = 1, type_role = 'CMS', pageSize = 1000 } = values || {}

    try {
      const body = {
        type_role,
        page,
        pageSize
      }
      const res = await userSearch(body) // Assuming roleSearch is an API function

      if (res && res.data) {
        setListUserAccess(res.data) // Update the state with the list of roles
      } else {
        setListUserAccess([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListUserAccess([])
    } finally {
    }
  }

  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="vertical"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Mục"
        name="code"
        rules={[{ required: true, message: 'Vui lòng chọn mục' }]}
      >
        <Select
          placeholder="Chọn mục"
          onChange={(value) => {
            form.setFieldsValue({ type: "Text" })
            if (value == 'USER_ACCESS') {
              getListUserAccess()
            }
          }}
        >
          {OPTIONS_CODE.map((item, idx) => {
            return <Option value={item.value}>{item.name}</Option>
          })}
        </Select>
      </Form.Item>
      <Form.Item
        label="Type"
        name="type"
        rules={[{ required: true, message: 'Vui lòng chọn type' }]}
      >
        <Select placeholder="Chọn type">
          <Option value="Text">Text</Option>
          <Option value="link">Link</Option>
          <Option value="STK">STK</Option>
        </Select>
      </Form.Item>

      {/* STK Fields */}
      {type === 'STK' && (
        <>
          <Form.Item
            label="Ngân hàng"
            name="bank_name"
            rules={[{ required: true, message: 'Nhập tên ngân hàng' }]}
          >
            <Input placeholder="Tên ngân hàng" />
          </Form.Item>
          <Form.Item
            label="Số tài khoản"
            name="account_number"
            rules={[{ required: true, message: 'Nhập số tài khoản' }]}
          >
            <Input placeholder="Số tài khoản" />
          </Form.Item>
          <Form.Item
            label="Chủ tài khoản"
            name="account_holder"
            rules={[{ required: true, message: 'Nhập chủ tài khoản' }]}
          >
            <Input placeholder="Chủ tài khoản" />
          </Form.Item>
        </>
      )}

      {/* Upload file nếu là link */}
      {type === 'link' && (
        <>
          <Form.Item label="Upload file">
            {!uploadedFileUrl ? (
              <Upload
                name="file"
                customRequest={handleUpload}
                showUploadList={false}
                disabled={uploading}
              >
                <Button icon={<UploadOutlined />} loading={uploading}>
                  Tải tệp lên
                </Button>
              </Upload>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  justifyContent: 'space-between'
                }}
              >
                <a
                  href={uploadedFileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: '80%' }}
                >
                  {uploadedFileUrl}
                </a>
                <Button
                  style={{ width: 30, height: 25 }}
                  icon={<DeleteOutlined />}
                  onClick={handleDelete}
                  danger
                />
              </div>
            )}
          </Form.Item>
          <Form.Item name="value" hidden>
            <Input />
          </Form.Item>
        </>
      )}

      {/* Text nhập nếu là Text */}
      {type === 'Text' && code == 'USER_ACCESS' && (
        <Form.Item
          label="User truy cập"
          name="user_access"
          // rules={[{ required: true, message: 'Chọn user truy cập' }]}
        >
          <Select placeholder="Chọn user truy cập" mode="multiple" allowClear showSearch filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}>
            {listUserAccess?.list?.map((item, idx) => {
              return (
                <Option key={idx} value={item.email}>
                  {item.email}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
      )}

      {/* Text nhập nếu là Text */}
      {type === 'Text' && code != 'DEPARTMENT' && code != 'USER_ACCESS' && (
        <Form.Item
          label="Giá trị"
          name="value"
          rules={[{ required: true, message: 'Nhập giá trị' }]}
        >
          <Input placeholder="Nhập giá trị" />
        </Form.Item>
      )}
      {/* Text nhập nếu là Text */}
      {type === 'Text' && code == 'DEPARTMENT' && (
        <Form.Item label="Sàn mặc định" name="value">
          <Select
            style={{ width: '100%' }}
            placeholder="Chọn sàn mặc định"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase()
              const optionValue = removeVietnameseTones(
                option?.children || ''
              ).toLowerCase()
              return optionValue.includes(inputValue)
            }}
          >
            {listDepartmentFull?.map((item, idx) => {
              return (
                <Option key={idx} value={String(item.id)}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
      )}
    </Form>
  )
}

export default FormPost
